"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var provider_1 = require("../../../theme/provider");
var chroma_js_1 = require("chroma-js");
var utils_1 = require("../../../utils/utils");
var StyledDiv = (0, styled_components_1.default)("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* Adapt the colors based on primary prop */\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 10px;\n  line-height: 1.3em;\n  border: none;\n  padding: 6px 12px;\n  border-radius: ", "px;\n  -webkit-font-smoothing: antialiased;\n  box-sizing: border-box;\n  display: inline-flex;\n  text-transform: uppercase;\n"], ["\n  /* Adapt the colors based on primary prop */\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 10px;\n  line-height: 1.3em;\n  border: none;\n  padding: 6px 12px;\n  border-radius: ", "px;\n  -webkit-font-smoothing: antialiased;\n  box-sizing: border-box;\n  display: inline-flex;\n  text-transform: uppercase;\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return (color !== null && color !== void 0 ? color : (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__colorBackground, theme.primaryColor, (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__primaryColor, theme.primaryColor, "black")));
}, function (props) { return (props.lightContrast ? "#fff" : "#000"); }, function (props) { return (0, provider_1.getFontFromTheme)(props.theme).fontFamily; }, function (props) { var _a; return ((_a = props.theme) === null || _a === void 0 ? void 0 : _a.buttonRadius) || 2; });
var Badge = function (_a) {
    var children = _a.children, color = _a.color, _b = _a.className, className = _b === void 0 ? "" : _b, props = __rest(_a, ["children", "color", "className"]);
    var theme = React.useContext(styled_components_1.ThemeContext);
    var cts = React.useMemo(function () {
        return (0, chroma_js_1.contrast)("#fff", color || theme.primaryColor) >= 2.5;
    }, [color || theme.primaryColor]);
    return ((0, jsx_runtime_1.jsx)(StyledDiv, __assign({ lightContrast: cts, color: color }, props, { className: "wellms-component ".concat(className) }, { children: children })));
};
exports.Badge = Badge;
// https://styled-components.com/docs/api#using-custom-props
var NewButton = (0, styled_components_1.default)(exports.Badge)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
// Main button with styles
exports.default = (0, styled_components_1.withTheme)(NewButton);
var templateObject_1, templateObject_2;
